import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

function DeleteComponent({ isDeleteDialogOpen, setIsDeleteDialogOpen, selectedRows, handleDelete }) {
    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            open={isDeleteDialogOpen}
            fullWidth={true}
            sx={{
                "& .MuiDialog-paper": {
                    maxWidth: "500px",
                    width: "100%",
                },
            }}
        >
            <DialogContent>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px 50px",
                    }}
                >
                    <p
                        style={{
                            fontSize: 14,
                            fontWeight: 900,
                            textAlign: "center",
                        }}
                    >
                        This action will permanently delete the selected records. Do you wish to continue?
                    </p>
                    <ul
                        style={{
                            alignSelf: "flex-start",
                            paddingLeft: "80px",
                            fontSize: 15,
                        }}
                    >
                        {selectedRows.map((datum) => {
                            return <li key={datum.id}>{datum.backend_variable}</li>;
                        })}
                    </ul>
                </div>
            </DialogContent>
            <DialogActions
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    paddingBottom: "20px",
                }}
            >
                <div>
                    <Button
                        className="custom-btn mx-2 px-3"
                        variant="outlined"
                        size="small"
                        onClick={() => setIsDeleteDialogOpen(false)}
                    >
                        Disagree
                    </Button>
                    <Button
                        className="custom-btn mx-2 px-4"
                        size="small"
                        autoFocus
                        variant="outlined"
                        color="error"
                        onClick={handleDelete}
                    >
                        Agree
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

// PropTypes
DeleteComponent.propTypes = {
    isDeleteDialogOpen: PropTypes.bool,
    setIsDeleteDialogOpen: PropTypes.func,
    selectedRows: PropTypes.array,
    handleDelete: PropTypes.func,
};

export default DeleteComponent;
